import { IParamsGetJobTitleManagement } from 'app/api/jobtitle/model/job-title-management'

export const JobTitleKeys = {
  allJobTitles: ['JobTitles'] as const,
  listJobTitles: () => [...JobTitleKeys.allJobTitles, 'JobTitles'] as const,
  listJobTitle: (filters?: IParamsGetJobTitleManagement) =>
    [...JobTitleKeys.listJobTitles(), { filters }] as const,
}
